import {
  collection,
  getDocs,
  updateDoc,
  doc,
  query,
  orderBy,
} from "firebase/firestore";
import { dbLOA as db } from "../../../../backend/firebaseConfig";

const ISSUE_REPORTS_COLLECTION = "ProviderNetworkIssueReports";

export const PROVIDER_ISSUE_STATUS_OPTIONS = [
  { value: "open", label: "Open" },
  { value: "in_progress", label: "In Progress" },
  { value: "resolved", label: "Resolved" },
  { value: "closed", label: "Closed" },
];

export const getProviderIssueReports = async () => {
  const reportsQuery = query(
    collection(db, ISSUE_REPORTS_COLLECTION),
    orderBy("createdAt", "desc"),
  );

  const snap = await getDocs(reportsQuery);

  return snap.docs.map((docSnap) => ({
    id: docSnap.id,
    ...docSnap.data(),
  }));
};

export const updateProviderIssueReport = async ({
  reportId,
  status,
  internalNotes,
  updatedBy,
}) => {
  if (!reportId) {
    throw new Error("Report ID is required.");
  }

  const reportRef = doc(db, ISSUE_REPORTS_COLLECTION, reportId);

  await updateDoc(reportRef, {
    status: status || "open",
    internalNotes: internalNotes || "",
    updatedBy: updatedBy || localStorage.getItem("userEmail") || "",
    updatedAt: new Date().toISOString(),
  });

  return true;
};
